const mutations = {
  showBurgerMenu(state) {
    state.isBurgerMenuOpen = true;
  },
  hideBurgerMenu(state) {
    state.isBurgerMenuOpen = false;
  },
  showOverlay(state) {
    state.isOverlayVisible = true;
  },
  hideOverlay(state) {
    state.isOverlayVisible = false;
  },
  updateCartCount(state, updatedCartData) {
    state.basketCount = updatedCartData.cart.size;
  },
  showMinicart(state, data) {
    if(data.cart) {
      state.cart = data.cart;
      state.miniFlyout.show = 'cart';
      state.miniFlyout.itemAdded = 'cart';
      state.miniFlyout.temporary = data.temporary;
      if (data.temporary) {
        setTimeout(() => {
          state.miniFlyout.itemAdded = null;
        }, 3000)
      }
    }
  },
  editProduct(state, updatedData) {
    state.editedProduct = updatedData;
  },
  showModal(state, data) {
    state.currentModalId = data.id;
    state.isOverlayVisible = true;
    state.isModalOpened = true;
  },
  hideModal(state) {
    state.currentModalId = '';
    state.isOverlayVisible = false;
    state.isModalOpened = false;
  },
  updateCart(state, newCart) {
    if (newCart) {
      state.cartPage = newCart;
      state.cart = newCart;
    }
  },
  editArticleInFlyout(state, data) {
    const cart = state.cart.positions;
    const addedItem = data.itemId;

    if(data.type === 'delete') {
      /*remove item from cart flyout*/
      let deletedItemIndex =  cart.findIndex(deletedItem => deletedItem.itemId === addedItem);
      cart.splice(deletedItemIndex, 1);
    }
  },
  reduceCount(state, data) {
    if(data.flyout === 'cart') {
      state.basketCount -= 1;
    }
  },
  addCount(state, data) {
    if(data.flyout === 'cart') {
      state.basketCount += 1;
    }
  }
};

export default mutations;
